export const getRawProceeds = ({
  multiple,
  ltm,
}: {
  multiple: number;
  ltm: number;
}) => multiple * ltm;

export const getTotalProceedsCalculator = ({
  rxFee,
  ltm,
}: {
  rxFee: number;
  ltm: number;
}) => (multiple: number) => (1 - rxFee) * getRawProceeds({ ltm, multiple });

export const computeBuyerFee = (amount: number) => Math.max(0.01 * amount, 500);

export const getTrailingYield = (ltm: number, amount: number) =>
  amount ? ((ltm / amount) * 100).toFixed(2) : 0;

export const getReturnOnInvestment = (
  royaltiesReceived: string,
  saleProceeds: number,
  purchasedAmount: string,
  buyersFee: string,
) => {
  const royalties = parseFloat(royaltiesReceived);
  const purchasedPrice = parseFloat(purchasedAmount) + parseFloat(buyersFee);
  return (royalties + saleProceeds - purchasedPrice) / purchasedPrice;
};
